import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './reset-password.html',
  styleUrls: ['./reset-password.scss']
})
export class ResetPasswordComponent implements OnInit {

  token = '';
  newPassword = '';
  confirmPassword = '';

  loading = false;
  message = '';
  error = '';
  done = false;

  apiUrl = 'https://superbangladesh-api-1.onrender.com';

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    public languageService: LanguageService
  ) {}

  t(key: string): string {
    return this.languageService.translate(key);
  }

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';

    if (!this.token) {
      this.error = this.t('invalidLinkNoToken');
    }
  }

  submit() {

    this.message = '';
    this.error = '';

    if (!this.token) {
      this.error = this.t('invalidLink');
      return;
    }

    if (!this.newPassword || this.newPassword.length < 6) {
      this.error = this.t('passwordMinLength');
      return;
    }

    if (this.newPassword !== this.confirmPassword) {
      this.error = this.t('passwordsDontMatch');
      return;
    }

    this.loading = true;

    this.http.post<any>(
      `${this.apiUrl}/api/auth/reset-password`,
      { token: this.token, newPassword: this.newPassword }
    ).subscribe({

      next: (res) => {

        this.loading = false;

        // ✅ Backend আগের মতোই fixed message পাঠায় (Bangla),
        // frontend সেটাকে না দেখিয়ে current language অনুযায়ী
        // নিজের translated message দেখায়।
        if (res.error) {
          this.error = this.t('linkExpiredOrInvalid');
          return;
        }

        this.done = true;
        this.message = this.t('passwordChangedSuccess');

        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2500);
      },

      error: () => {
        this.loading = false;
        this.error = this.t('somethingWentWrongTryAgain');
      }
    });
  }
}
